// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pj-0";
export var leftAlign = "_pj-4";
export var listItem = "_pj-2";
export var listItemWrapper = "_pj-1";
export var operationText = "_pj-3";